import React from "react";
import "./TableData.css";
import { waysToPayOff } from "../content";
import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  tableCellClasses,
  TextField,
  Typography,
  styled,
} from "@mui/material";

const TableData = () => {
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  }));

  // Styling Table Cell
  const tableHeadingsStyle = {
    xs: "14px",
    lg: "16px",
  };
  const tableContentStyle = {
    md: "14px",
    lg: "16px",
  };

  return (
    <>
      <div>
        <Typography
          sx={{ fontFamily: "'Archivo', sans-serif", fontSize: "16px" }}
        >
          {waysToPayOff[0].tableinfo}
        </Typography>
        <div className="mt-4">
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow
                  sx={{
                    // backgroundColor: "#e6c1fd",
                    // backgroundColor: "#E2E3E5",
                    backgroundColor: "#E7E4F9",
                  }}
                >
                  <TableCell
                    sx={{
                      fontSize: tableHeadingsStyle,
                      fontFamily: "'Archivo', sans-serif",
                      borderRight: "1px solid #c7c7c7",
                    }}
                    className="archivo"
                  >
                    Principal (₹)
                  </TableCell>
                  <TableCell
                    sx={{
                      fontSize: tableHeadingsStyle,
                      fontFamily: "'Archivo', sans-serif",
                      borderRight: "1px solid #c7c7c7",
                    }}
                    className="archivo"
                  >
                    Monthly Payment (₹)
                  </TableCell>
                  <TableCell
                    sx={{
                      fontSize: tableHeadingsStyle,
                      fontFamily: "'Archivo', sans-serif",
                      borderRight: "1px solid #c7c7c7",
                    }}
                    className="archivo"
                  >
                    Interest Rate (APR %){" "}
                  </TableCell>
                  <TableCell
                    sx={{
                      fontSize: tableHeadingsStyle,
                      fontFamily: "'Archivo', sans-serif",
                      borderRight: "1px solid #c7c7c7",
                    }}
                    className="archivo"
                  >
                    Total Interest Paid (₹){" "}
                  </TableCell>
                  <TableCell
                    sx={{
                      fontSize: tableHeadingsStyle,
                      fontFamily: "'Archivo', sans-serif",
                      borderRight: "1px solid #c7c7c7",
                    }}
                    className="archivo"
                  >
                    Total Amount Paid (₹){" "}
                  </TableCell>
                  <TableCell
                    sx={{
                      fontSize: tableHeadingsStyle,
                      fontFamily: "'Archivo', sans-serif",
                      borderRight: "1px solid #c7c7c7",
                    }}
                    className="archivo"
                  >
                    Time to Pay Off Debt{" "}
                  </TableCell>
                  <TableCell
                    sx={{
                      fontSize: tableHeadingsStyle,
                      fontFamily: "'Archivo', sans-serif",
                      borderRight: "1px solid #c7c7c7",
                    }}
                    className="archivo"
                  >
                    Impact{" "}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <StyledTableRow>
                  <StyledTableCell
                    sx={{
                      fontSize: tableContentStyle,
                      fontFamily: "'Archivo', sans-serif",
                      borderRight: "1px solid #E0E0E0",
                    }}
                  >
                    ₹1,00,000
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      fontSize: tableContentStyle,
                      fontFamily: "'Archivo', sans-serif",
                      borderRight: "1px solid #E0E0E0",
                    }}
                  >
                    ₹10,000{" "}
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      fontSize: tableContentStyle,
                      fontFamily: "'Archivo', sans-serif",
                      borderRight: "1px solid #E0E0E0",
                    }}
                  >
                    12%{" "}
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      fontSize: tableContentStyle,
                      fontFamily: "'Archivo', sans-serif",
                      borderRight: "1px solid #E0E0E0",
                    }}
                  >
                    ₹6,000{" "}
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      fontSize: tableContentStyle,
                      fontFamily: "'Archivo', sans-serif",
                      borderRight: "1px solid #E0E0E0",
                    }}
                  >
                    ₹1,06,000
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      fontSize: tableContentStyle,
                      fontFamily: "'Archivo', sans-serif",
                      borderRight: "1px solid #E0E0E0",
                    }}
                  >
                    12 months{" "}
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      fontSize: tableContentStyle,
                      fontFamily: "'Archivo', sans-serif",
                      borderRight: "1px solid #E0E0E0",
                    }}
                  >
                    Manageable and quick repayment. Save with higher payments.{" "}
                  </StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell
                    sx={{
                      fontSize: tableContentStyle,
                      fontFamily: "'Archivo', sans-serif",
                      borderRight: "1px solid #E0E0E0",
                    }}
                  >
                    ₹1,00,000
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      fontSize: tableContentStyle,
                      fontFamily: "'Archivo', sans-serif",
                      borderRight: "1px solid #E0E0E0",
                    }}
                  >
                    ₹5,000{" "}
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      fontSize: tableContentStyle,
                      fontFamily: "'Archivo', sans-serif",
                      borderRight: "1px solid #E0E0E0",
                    }}
                  >
                    12%
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      fontSize: tableContentStyle,
                      fontFamily: "'Archivo', sans-serif",
                      borderRight: "1px solid #E0E0E0",
                    }}
                  >
                    ₹24,000{" "}
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      fontSize: tableContentStyle,
                      fontFamily: "'Archivo', sans-serif",
                      borderRight: "1px solid #E0E0E0",
                    }}
                  >
                    ₹1,24,000
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      fontSize: tableContentStyle,
                      fontFamily: "'Archivo', sans-serif",
                      borderRight: "1px solid #E0E0E0",
                    }}
                  >
                    24 months{" "}
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      fontSize: tableContentStyle,
                      fontFamily: "'Archivo', sans-serif",
                      borderRight: "1px solid #E0E0E0",
                    }}
                  >
                    Increased interest over a longer period. Leads to higher
                    total cost.
                  </StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell
                    sx={{
                      fontSize: tableContentStyle,
                      fontFamily: "'Archivo', sans-serif",
                      borderRight: "1px solid #E0E0E0",
                    }}
                  >
                    ₹1,00,000
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      fontSize: tableContentStyle,
                      fontFamily: "'Archivo', sans-serif",
                      borderRight: "1px solid #E0E0E0",
                    }}
                  >
                    ₹2,500{" "}
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      fontSize: tableContentStyle,
                      fontFamily: "'Archivo', sans-serif",
                      borderRight: "1px solid #E0E0E0",
                    }}
                  >
                    18%
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      fontSize: tableContentStyle,
                      fontFamily: "'Archivo', sans-serif",
                      borderRight: "1px solid #E0E0E0",
                    }}
                  >
                    ₹52,000{" "}
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      fontSize: tableContentStyle,
                      fontFamily: "'Archivo', sans-serif",
                      borderRight: "1px solid #E0E0E0",
                    }}
                  >
                    ₹1,52,000
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      fontSize: tableContentStyle,
                      fontFamily: "'Archivo', sans-serif",
                      borderRight: "1px solid #E0E0E0",
                    }}
                  >
                    48 months{" "}
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      fontSize: tableContentStyle,
                      fontFamily: "'Archivo', sans-serif",
                      borderRight: "1px solid #E0E0E0",
                    }}
                  >
                    Very high interest cost with prolonged repayment. Needs
                    optimization.{" "}
                  </StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell
                    sx={{
                      fontSize: tableContentStyle,
                      fontFamily: "'Archivo', sans-serif",
                      borderRight: "1px solid #E0E0E0",
                    }}
                  >
                    ₹1,00,000
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      fontSize: tableContentStyle,
                      fontFamily: "'Archivo', sans-serif",
                      borderRight: "1px solid #E0E0E0",
                    }}
                  >
                    ₹1000{" "}
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      fontSize: tableContentStyle,
                      fontFamily: "'Archivo', sans-serif",
                      borderRight: "1px solid #E0E0E0",
                    }}
                  >
                    24%
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      fontSize: tableContentStyle,
                      fontFamily: "'Archivo', sans-serif",
                      borderRight: "1px solid #E0E0E0",
                    }}
                  >
                    ₹1,02,000
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      fontSize: tableContentStyle,
                      fontFamily: "'Archivo', sans-serif",
                      borderRight: "1px solid #E0E0E0",
                    }}
                  >
                    ₹2,02,000
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      fontSize: tableContentStyle,
                      fontFamily: "'Archivo', sans-serif",
                      borderRight: "1px solid #E0E0E0",
                    }}
                  >
                    60 months{" "}
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      fontSize: tableContentStyle,
                      fontFamily: "'Archivo', sans-serif",
                      borderRight: "1px solid #E0E0E0",
                    }}
                  >
                    Extremely high interest and extended repayment period.
                    Consider balance transfer to reduce costs.{" "}
                  </StyledTableCell>
                </StyledTableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>

      <section>
        <div id="key_infomation" className=" mt-5">
          <Typography
            sx={{
              fontFamily: "'Archivo', sans-serif",
              fontSize: "20px",
              lineHeight: "24px",
              letterSpacing: "normal",
              textAlign: "start",
              fontWeight: 700,
              color: "#1F1F1F",
            }}
          >
            {waysToPayOff[0].infoheading}
          </Typography>
          <div id="key_list">
            <ul
              style={{
                listStyle: "disc",
                fontSize: 16,
                color: "#1f1f1f",
                lineHeight: "24px",
              }}
              className=" archivo mt-3"
            >
              {waysToPayOff[0].infoList &&
                waysToPayOff[0].infoList.map((item, index) => (
                  <li key={index}>
                    <strong>{item.info}</strong>
                    {item.description}
                  </li>
                ))}
            </ul>
          </div>
        </div>
        <div className="pt-3 pb-4 d-flex flex-column gap-2">
          <Typography
            sx={{
              fontFamily: "'Archivo', sans-serif",
              fontSize: "20px",
              lineHeight: "24px",
              letterSpacing: "normal",
              textAlign: "start",
              fontWeight: 700,
              color: "#1F1F1F",
            }}
          >
            {waysToPayOff[0].ways}
          </Typography>
          <div id="ways_list">
            <ol
              style={{ fontSize: 16, color: "#1f1f1f", lineHeight: "24px" }}
              className=" archivo "
            >
              {waysToPayOff[0].waysInfolist &&
                waysToPayOff[0].waysInfolist.map((item, index) => (
                  <li key={index} className="mt-3">
                    <strong>{item.info}</strong> {item.description}
                  </li>
                ))}
            </ol>
          </div>
        </div>
      </section>
    </>
  );
};

export default TableData;
